
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import UserEditor from '@/views/module-user-manage/user-editor.vue'
import UserChargeEditor from '@/views/module-user-manage/user-charge-editor.vue'
import OrderInfo from '@/model/modules/OrderInfo'
import OrderService from '@/service/modules/OrderService'
import DateUtil from '@/utils/DateUtil'
import OrderUploader from '@/views/module-order-manage/order-uploader.vue'
import OrderEditor from '@/views/module-order-manage/order-editor.vue'
import StorageKeyDefineLogin from '@/define/storage/login'
import CourierInfo from '@/model/modules/CourierInfo'
import CourierService from '@/service/modules/CourierService'
import UserInfoService from '@/service/modules/UserInfoService'

@Component({
  components: {OrderEditor, OrderUploader, UserChargeEditor, UserEditor}
})
export default class ModuleOrderManage extends Vue {
  @Prop()
  propUserId!: number | undefined

  courierList: any[] = [
    {id: '3', courierName: 'shipgadget'},
    {id: '6', courierName: 'IB Blue'}
  ]

  userId: number | undefined = undefined

  listLoadingState: boolean = false
  draftHeaderDefine: any = [
    {text: '订单ID', value: 'id', width: 90},
    {text: '订单号', value: 'orderNo'},
    {text: '跟踪号', value: 'mainOrderNo'},
    {text: '创建时间', value: 'createAt'},
    {text: '发件信息', value: 'fromUserDto.name', width: 100},
    {text: '收件人', value: 'receiveName'},
    {text: '商品单重', value: 'productWeight'},
    {text: '总金额', value: 'totalPrice', width: 100},
    {text: '物流方式', value: 'courierDto.courierName'},
    {text: '订单状态', value: 'status'},
    {text: '物流商报错', value: 'errorMessage', width: 100},
    {text: '订单检查报错', value: 'errorPostcodeMessage', width: 140},
    {text: '操作', value: 'action', sortable: false}
  ]

  headerDefine: any = [
    {text: '订单ID', value: 'id'},
    {text: '订单号', value: 'orderNo'},
    {text: '跟踪号', value: 'mainOrderNo'},
    {text: '下单批次号', value: 'batchNumber'},
    {text: '创建时间', value: 'createAt'},
    {text: '发件信息', value: 'fromUserDto.name'},
    {text: '收件人', value: 'receiveName'},
    {text: '商品单重', value: 'productWeight'},
    {text: '总金额', value: 'totalPrice'},
    {text: '物流方式', value: 'courierDto.courierName'},
    {text: '订单状态', value: 'status'},
    {text: '操作', value: 'action', sortable: false}
  ]

  dateUtil: DateUtil = DateUtil
  currentLoginUserGroup = ''

  queryLikeResult: BasePageableInfo<OrderInfo> = new BasePageableInfo<OrderInfo>()
  queryAllCount: number = 0
  queryType: string = 'orderNo'
  channel: string = ''
  queryWord: string = ''
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [
    {text: '20条/页', value: 20},
    {text: '50条/页', value: 50},
    {text: '200条/页', value: 200},
    {text: '500条/页', value: 500},
    {text: '1000条/页', value: 1000},
    {text: '2000条/页', value: 2000}]

  pickerOptions: any = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }]
  }

  dateFilterValue: Date[] = [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30), new Date(new Date().getTime() + 1000 * 60 * 60 * 24)]

  selectedItems: OrderInfo[] = []
  shiftKeyDownState: boolean = false
  shiftPreSelectIndex: number = -1
  filterStatus: string = ''

  mounted() {
    this.refreshAllData(this.userId)
    document.onkeydown = (e) => {
      if (e.keyCode === 16) {
        this.shiftKeyDownState = true
      }
    }
    document.onkeyup = (e) => {
      if (e.keyCode === 16) {
        this.shiftKeyDownState = false
      }
    }
  }

  onOrderTableRowClick(data: any, newData: any) {
    newData.select(true)
    const thisTimeIndex = this.queryLikeResult.dataList.indexOf(data)
    if (this.shiftPreSelectIndex === -1) {
      this.shiftPreSelectIndex = thisTimeIndex
    } else {
      if (this.shiftKeyDownState) {
        // 按下shift，多选
        // @ts-ignore
        window.getSelection().removeAllRanges()
        for (let i = Math.min(thisTimeIndex, this.shiftPreSelectIndex); i <= Math.max(thisTimeIndex, this.shiftPreSelectIndex); i++) {
          if (this.selectedItems.indexOf(this.queryLikeResult.dataList[i]) < 0) {
            this.selectedItems.push(this.queryLikeResult.dataList[i])
          }
        }
      } else {
        // 没有按下shift
        this.shiftPreSelectIndex = thisTimeIndex
      }
    }
  }

  @Watch('filterStatus')
  onFilterStatusChanged() {
    this.pageNum = 1
    this.selectedItems = []
    this.channel = ''
    this.refreshAllData(this.userId)
  }

  @Watch('channel')
  onChannelChanged() {
    this.pageNum = 1
    this.selectedItems = []
    this.refreshAllData(this.userId)
  }

  @Watch('pageNum')
  onPageNumChanged() {
    this.refreshAllData(this.userId)
  }

  @Watch('dateFilterValue')
  onDateFilterChanged() {
    this.refreshAllData(this.userId)
  }

  @Watch('pageSize')
  onPageSizeChanged() {
    this.pageNum = 1
    this.refreshAllData(this.userId)
  }

  refreshAllData(userId?: number) {
    this.selectedItems = []
    this.currentLoginUserGroup = sessionStorage[StorageKeyDefineLogin.LOGIN_USER_GROUP]
    this.userId = userId
    if (userId !== undefined) {
      this.queryLikeResult.dataList = []
    }
    this.listLoadingState = true
    const searchExample = {}
    searchExample[this.queryType] = this.queryWord
    // @ts-ignore
    searchExample.startTime = this.dateFilterValue[0].getTime()
    // @ts-ignore
    searchExample.endTime = this.dateFilterValue[1].getTime()
    // @ts-ignore
    searchExample.status = this.filterStatus
    // @ts-ignore
    searchExample.sortName = 'createAt'
    // @ts-ignore
    searchExample.sortOrder = 'desc'
    // @ts-ignore
    searchExample.channel = this.channel
    if (userId !== undefined) {
      // @ts-ignore
      searchExample.user = userId
    }
    // @ts-ignore
    if (searchExample.user === undefined) {
      // @ts-ignore
      searchExample.user = UserInfoService.getCurrentUserId()
    }
    // Promise.all([CourierService.listScanformChannel(example, 0, 99999), OrderService.list(searchExample, this.pageNum - 1, this.pageSize)])
    OrderService.list(searchExample, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<OrderInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
        this.queryAllCount = result.dataList.length === 0 ? 0 : result.dataList[0].totalSize
      })
  }

  exportAllData() {
    const searchExample = {}
    searchExample[this.queryType] = this.queryWord
    // @ts-ignore
    searchExample.startTime = this.dateFilterValue[0].getTime()
    // @ts-ignore
    searchExample.endTime = this.dateFilterValue[1].getTime()
    // @ts-ignore
    searchExample.status = this.filterStatus
    // @ts-ignore
    searchExample.user = this.userId
    // @ts-ignore
    searchExample.sortName = 'createAt'
    // @ts-ignore
    searchExample.sortOrder = 'desc'
    // @ts-ignore
    searchExample.page = this.pageNum - 1
    // @ts-ignore
    searchExample.size = this.pageSize
    OrderService.export(searchExample)
      .then((result: string) => {
        // @ts-ignore
        location.href = window.$HOST + '/core/downloadZip?typeKey=xlsx&fileKey=' + result
      })
  }

  newItem() {
    this.editItem(new OrderInfo())
  }

  editItem(item: OrderInfo) {
    const self = this
    // @ts-ignore
    this.$refs.orderEditor.showEditor(item, this.filterStatus !== '1', function () {
      self.refreshAllData(self.userId)
    })
  }

  uploadOrderExcel(isFreightTrial: boolean) {
    const self = this
    // @ts-ignore
    this.$refs.orderUploader.showUploader(isFreightTrial, () => {
      self.refreshAllData(self.userId)
    })
  }

  modifyOrderListState(newState: string, tipText: string, autoDownload: boolean) {
    this.$confirm(tipText, '订单状态修改', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: '正在处理订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      OrderService.updateOrderStatus(this.selectedItems, newState)
        .then(resp => {
          loading.close()
          if ((newState === '4' || newState === '5')) {
            if (autoDownload) {
              // @ts-ignore
              location.href = window.$HOST + 'core/downloadZip?fileKey=' + resp + '&typeKey=' + (newState === '4' ? 'zip' : 'xlsx')
            } else {
              this.$notify({
                title: '订单管理',
                message: '任务已经提交成功，请等待服务器处理',
                type: 'success'
              })
            }
          } else if (newState === '7') {
            if (autoDownload) {
              // @ts-ignore
              location.href = window.$HOST + 'core/downloadZip?fileKey=' + resp + '&typeKey=zip'
              this.$notify({
                title: '订单管理',
                message: '任务已经提交成功，请等待服务器处理',
                type: 'success'
              })
            }
          } else if ((newState === '6')) {
            if (autoDownload) {
              // @ts-ignore
              location.href = window.$HOST + 'core/download?fileKey=' + resp + '&typeKey=pdf'
            } else {
              this.$notify({
                title: '订单管理',
                message: '任务已经提交成功，请等待服务器处理',
                type: 'success'
              })
            }
          } else {
            if (resp.length > 0) {
              // admin在用户管理的查看订单中进行操作，resp == ['o', 'k']，这种情况不是出错了。
              if (resp[0] === 'o' && resp.length > 1 && resp[1] === 'k') {
                this.$alert('操作执行完毕。<br>\n', '订单管理', {
                  confirmButtonText: '我知道了',
                  dangerouslyUseHTMLString: true
                })
              } else {
                this.$alert('下单操作执行完毕，本次下单过程中有如下订单发生了错误：<br>\n' + resp, '订单管理', {
                  confirmButtonText: '我知道了',
                  dangerouslyUseHTMLString: true
                })
              }
              this.refreshAllData(this.userId)
              return
            }
            this.refreshAllData(this.userId)
          }
          this.$notify({
            title: '成功',
            message: '订单状态修改成功',
            type: 'success'
          })
        })
        .catch(e => {
          loading.close()
          this.refreshAllData(this.userId)
          // admin在用户管理的查看订单中进行操作，resp == ['o', 'k']，这种情况不是出错了。
          if (e.response && e.response.data && e.response.data.errMsg) {
            this.$alert('下单操作执行完毕，本次下单过程中有如下订单发生了错误：<br><br>\n' + e.response.data.errMsg.split(',').join('<br>'), '订单Excel上传', {
              confirmButtonText: '我知道了',
              dangerouslyUseHTMLString: true
            })
          } else {
            this.$alert('操作执行完毕，但发生了错误:' + e)
          }
        })
    })
  }

  deleteOrders() {
    this.$confirm('确认要将选中的订单彻底删除吗？删除后无法恢复', '彻底删除订单', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      OrderService.deleteOrderList(this.selectedItems)
        .then(resp => {
          loading.close()
          this.refreshAllData(this.userId)
          this.$notify({
            title: '成功',
            message: '订单状态修改成功',
            type: 'success'
          })
        })
        .catch(e => {
          loading.close()
        })
    })
  }
}
